import React from 'react';
import AddAutomationBtn from './AddAutomationBtn';
import robotImg from '../../../assets/images/robot.png';
const BlankAutomation = ({ setOpenForm }) => {
	return (
		<div className='hunterTabContent'>
			<div className='emptyMessageSettings'>
				<div className='emptyPortion automations'>
				
					<p style={{marginTop:"0"}}>
						You have not created any Automation yet. <br />
						Please create one.
					</p>
          <img src={robotImg} className='fileImg' alt='' />
          <span className="midBtnWraper">
          <AddAutomationBtn  setOpenForm={setOpenForm} />
          </span>
          
				</div>
			</div>
		</div>
	);
};

export default BlankAutomation;
